import type { ErrorResponse } from '@efacity/frontend-next-shared/notifications';

export const isResponseError = <AdditionalData = Record<string, unknown>>(
  error: unknown | ErrorResponse<AdditionalData>
): error is ErrorResponse<AdditionalData> => {
  return !!(error as ErrorResponse)?.response;
};
